import {ProfileStatusRepository} from "../../domain/repository";
import {ProfileStatusRepositoryV2} from "./repository.v2";

export type {ProfileStatusRepository} from "../../domain/repository";

/**
 * Factory that returns the repository implementation.
 *
 * v1 has been decommissioned; v2 is the only implementation.
 */
export const createProfileStatusRepository = (): ProfileStatusRepository => {
  return new ProfileStatusRepositoryV2();
};
